import React from "react";
import styles from './CheckInput.module.sass'

const CheckInput = ({ title, onChange }) => {

    return (
        <div className={'helperLink center'}>
            <label>
                {title}
            </label>
            <input type='checkbox' onChange={(event) => {onChange?.(event.target.checked)}}/>
        </div>
    )

};

export default CheckInput;